module.exports = __webpack_public_path__ + "img/sld_scb_23_t1_b1.cd0c9bd3.svg";